import notificationForSys from "../../../services/notificationForSys.service"

export default {
    createNotificationForSys({ dispatch }, params) {
        return notificationForSys.createNotificationsForSys(params)
            .then(response => {
                dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    createReadNotificationsForSys({ dispatch }, params) {
        return notificationForSys.createReadNotificationsForSys(params)
            .then(response => {
                Promise.resolve(response.data);
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    updateNotificationForSys({ commit, dispatch }, data) {
        return notificationForSys.updateNotificationsForSys(data)
            .then(response => {
                commit('UPDATE_NOTIFICATIONS_FOR_SYS', data)
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    searchNotificationsForSys({ commit, dispatch }, payload) {
        return notificationForSys.searchNotificationsForSys(payload)
            .then(response => {
                let notificationForSys = response.data.data.map((notification) => {
                    let postPeriod;
                    postPeriod =
                        notification.notification_start_date === null
                            ? '          '
                            : notification.notification_start_date;
                    postPeriod += ' ～ ';
                    postPeriod +=
                        notification.notification_end_date === null
                            ? '          '
                            : notification.notification_end_date;
                    notification.postPeriod = postPeriod;
                    return notification;
                });
                commit('SET_NOTIFICATIONS_FOR_SYS', notificationForSys)
                commit('SET_INFO_DB', { totalPage: response.data.last_page, totalRow: response.data.total })
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    getNotificationForSys({ dispatch }, id) {
        return notificationForSys.getNotificationsForSys(id)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    getUnreadNotificationForSys({ commit,dispatch }) {
        return notificationForSys.countUnreadNotificationForSys()
            .then(response => {
                commit('GET_UNREAD_NOTIFICATIONS_FOR_SYS', response.data)
                return Promise.resolve(response.data.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    deleteAllSelectNotificationsForSys({ commit, dispatch }, ids) {
        return notificationForSys.deleteAllSelectNotificationsForSys({ cids: ids })
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    readAllSelectNotificationsForSys({ commit, dispatch }, ids) {
        return notificationForSys.readAllSelectNotificationsForSys({ cids: ids })
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
}